import { render, staticRenderFns } from "./allNav.vue?vue&type=template&id=addb5eda&scoped=true&"
import script from "./allNav.vue?vue&type=script&lang=js&"
export * from "./allNav.vue?vue&type=script&lang=js&"
import style0 from "./allNav.vue?vue&type=style&index=0&id=addb5eda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addb5eda",
  null
  
)

export default component.exports